import Box from '@talkdesk/cobalt-react-box'
import Flex from '@talkdesk/cobalt-react-flex'
import { Text } from '@talkdesk/cobalt-react-typography'
import Image from '@talkdesk/cobalt-react-image'
import { useTranslation } from 'react-i18next'
import {
  GOOGLE_LOGO,
  MICROSOFT_LOGO,
  OKTA_LOGO,
  ONELOGIN_LOGO,
  SALESFORCE_LOGO,
} from '../../constants/images'
import Button from '@talkdesk/cobalt-react-button'
import { Icon } from '@talkdesk/cobalt-react-icon'

const identityProviderLogoSelector = (name, brandAssetsURL) =>
  ({
    Google: GOOGLE_LOGO(brandAssetsURL),
    Microsoft: MICROSOFT_LOGO(brandAssetsURL),
    Salesforce: SALESFORCE_LOGO(brandAssetsURL),
    Okta: OKTA_LOGO(brandAssetsURL),
    OneLogin: ONELOGIN_LOGO(brandAssetsURL),
  })[name]

const IdentityProviderButton = (props) => {
  const { t } = useTranslation()
  const { name, url, brandAssetsURL, redirect, disabled } = props
  const identityProviderLogo = identityProviderLogoSelector(
    name,
    brandAssetsURL,
  )

  return (
    <>
      <Button
        disabled={disabled}
        type='secondary'
        shape='full-width'
        onClick={() => redirect(url)}
      >
        <Flex alignY='center' width='100%'>
          <Flex width='20px' height='20px' alignX='center' alignY='center'>
            {identityProviderLogo ? (
              <Image src={identityProviderLogo} alt='' width={20} height={20} />
            ) : (
              <Icon name='lock_outline' size='tiny' />
            )}
          </Flex>
          <Flex grow alignX='center'>
            <Text as='span'>
              {t('identityProvider.login', {
                identityProviderName: name,
              })}
            </Text>
          </Flex>
          <Flex width='20px' />
        </Flex>
      </Button>
      <Box paddingTop={2} />
    </>
  )
}

export default IdentityProviderButton
